'use client';
import { ComponentType } from 'react';
import { Props as ContactComponentProps } from './contact.component';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import dynamic from 'next/dynamic';

const DynamicContactComponent: ComponentType<ContactComponentProps> = dynamic(
  () => import('./contact.component')
);

export default DynamicContactComponent;

export function calculateContactPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 200 },
    { sinceWidth: 768, height: 250 },
    { sinceWidth: 1024, height: 400 }
  ];

  return {
    heightSinceWidth
  };
}
